import Axios from 'axios';
import emitter from '@shared/utils/EventBus';

// console.log(import.meta.env.MODE);
// For mode development or production
// https://vite.dev/guide/env-and-mode
const mode = process.env.NODE_ENV;

let ajax_url = '';

if (process.env.VUE_APP_API && process.env.VUE_APP_API === 'local') {
  ajax_url = 'https://creators.lab.cj.com:8443/api/v1'//'https://cj-qa.app.anchor.store:8443/api/v1';
} else if (mode === 'development') {
  ajax_url = 'https://creators.lab.cj.com/api/v1'//'https://cj-qa.app.anchor.store/api/v1';
} else {
  ajax_url = '/api/v1';
}

const headers = {};
headers.Accept = 'application/json';
headers['Content-Type'] = 'application/json';
const token = window.localStorage.getItem('token');
if (token !== null) {
  headers.Authorization = 'Bearer ' + token;
}

const ajax = Axios.create({
  baseURL: ajax_url,
  headers: headers,
  withCredentials: true,
});

// Global request interceptor
ajax.interceptors.request.use(
  (config) => {
    // Add token to request header
    const token = window.localStorage.getItem('token'); // Get token from local storage
    if (token) {
      // If token exists, add it to the header
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Global response interceptor
ajax.interceptors.response.use(
  // when response status is 200
  (res) => {
    if (res.config.url === '/me') {
      // window.creator_porta_user = res.data.data;
      emitter.emit('update-user-info', res.data.data);
    }

    return res;
  },

  // when response status is not 200
  (error) => {
    // check login status is expired
    if (
      error &&
      error.response &&
      error.response.data &&
      (error.response.data.message === 'System Error User is not logged in.' ||
        error.response.data.message === 'AuthenticationException with message Unauthenticated.')
    ) {
      window.localStorage.removeItem('token');
      if (window.location.pathname !== '/login' && window.location.pathname !== '/register') {
        window.location.replace('/login');
      }
    }

    throw error;
  }
);

export default ajax;